import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, filter } from 'rxjs/operators';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';

export const trackCheckoutViewed = (
  action$: Observable<LocationChangeAction>
) =>
  action$.pipe(
    ofType(LOCATION_CHANGE),
    filter((action) => action.payload.location.pathname.startsWith('/payment')),
    map(() => {
      if (window.analytics) {
        window.analytics.track('Checkout Step Viewed', {});
      }
    }),
    filter(() => false)
  );
